import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css' // Obligatoire pour la V1

inputs.types.cropper = function (data, name, niceName, type, input, parent, inputWindow) {
    const inputArea = input.parent('.field__area')
    const image = inputArea.find('img')
    let cropper = null
    let isReady = false
    let isResizing = false // Verrouille l'événement crop, PAS le changement de taille visuel
    let svgRatio = { x: 1, y: 1 } // Permettra de corriger l'échelle si c'est un SVG

    if (image.length === 0) {
        console.warn("[Cropper Debug] Aucune image trouvée dans .field__area");
        return data;
    }
    const imgElement = image[0]

    console.log("[Cropper Debug] Initialisation pour :", name, {
        src: imgElement.src,
        complete: imgElement.complete,
        naturalWidth: imgElement.naturalWidth,
        naturalHeight: imgElement.naturalHeight
    });

    // Récupère la valeur initiale depuis l'input (format : "x,y,w,h")
    const parseInputVal = (val) => {
        if (!val) return null
        const parts = val.split(',').map(Number)
        if (parts.length < 4) return null
        const [x, y, w, h] = parts
        return (w > 0 && h > 0) ? { x, y, width: w, height: h } : null
    }

    // Adapte les données selon le ratio SVG (Évite la duplication de logique)
    const getAdaptedData = (rectData) => {
        if (!rectData) return null
        return {
            x: rectData.x / svgRatio.x,
            y: rectData.y / svgRatio.y,
            width: rectData.width / svgRatio.x,
            height: rectData.height / svgRatio.y
        }
    }

    // Extrait les dimensions du viewBox du SVG si width/height sont absents
    const getSvgViewBoxDimensions = async (url) => {
        console.log("[Cropper Debug] Tentative de récupération du SVG via fetch...", url);
        try {
            const response = await fetch(url, { mode: 'cors' })
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            
            const text = await response.text()
            const xmlDoc = new DOMParser().parseFromString(text, "image/svg+xml")
            const parserError = xmlDoc.querySelector('parsererror');
            
            if (parserError) {
                console.error("[Cropper Debug] Erreur de parsing XML du SVG :", parserError.textContent);
                return null;
            }

            const svgTag = xmlDoc.querySelector("svg")
            if (!svgTag) {
                console.warn("[Cropper Debug] Balise <svg> introuvable dans le code récupéré.");
                return null;
            }

            console.log("[Cropper Debug] Attributs SVG trouvés :", {
                viewBox: svgTag.getAttribute("viewBox"),
                width: svgTag.getAttribute("width"),
                height: svgTag.getAttribute("height")
            });

            if (svgTag.hasAttribute("viewBox")) {
                const viewBox = svgTag.getAttribute("viewBox").split(' ').map(Number)
                if (viewBox.length === 4 && viewBox[2] > 0 && viewBox[3] > 0) {
                    return { width: viewBox[2], height: viewBox[3] }
                }
            } else {
                console.warn("[Cropper Debug] Le SVG n'a pas d'attribut viewBox.");
            }
        } catch (e) {
            console.error("[Cropper Debug] Erreur fatale lors de la lecture de la viewBox :", e)
        }
        return null
    }

    // 1. Initialisation de l'instance Cropper V1
    const initCropper = () => {
        if (imgElement.cropper) {
            console.log("[Cropper Debug] Destruction de l'ancienne instance Cropper");
            imgElement.cropper.destroy()
        }

        const adaptedInitialData = getAdaptedData(parseInputVal(input.val()))
        if (adaptedInitialData) {
            console.log("[Cropper Debug] Données initiales adaptées pour CropperJS :", adaptedInitialData);
        }

        cropper = new Cropper(imgElement, {
            viewMode: 1,
            dragMode: 'crop', 
            movable: false,
            zoomable: false,
            rotatable: false,
            scalable: false,
            zoomOnTouch: false,
            zoomOnWheel: false,
            autoCropArea: adaptedInitialData ? 0 : 1, 
            toggleDragModeOnDblclick: false,
            responsive: true,
            restore: false,
            checkCrossOrigin: false,

            ready() {
                isReady = true;
                console.log("[Cropper Debug] CropperJS prêt. Attente de la fin de l'animation d'ouverture.");
                
                // --- ATTENTE INITIALE : Nécessaire pour le premier ratio propre ---
                setTimeout(() => {
                    console.log("[Cropper Debug] Viewport stabilisé, recalibrage final.");
                    cropper.initContainer(); 

                    if (adaptedInitialData) {
                        cropper.setData(adaptedInitialData)
                    } else {
                        cropper.reset();
                    }
                }, 1000);

                // --- GESTION DU REDIMENSIONNEMENT FLUIDE ---
                let resizeTimeout;
                window.addEventListener('resize', () => {
                    isResizing = true; 
                    clearTimeout(resizeTimeout);
                    resizeTimeout = setTimeout(() => {
                        console.log("[Cropper Debug] Resize terminé. Recalcul et réapplication des positions absolues.");
                        
                        const currentData = cropper.getData();
                        cropper.initContainer();
                        cropper.setData(currentData);
                        
                        isResizing = false; // Réactive l'événement crop
                    }, 200);
                });
            },

            crop(event) {
                if (!isReady || input.data('cropperSetting') || isResizing) return

                const { x, y, width, height } = event.detail

                // CORRECTION MATHÉMATIQUE : On multiplie par le ratio viewBox/rendu
                const realX = Math.round(x * svgRatio.x)
                const realY = Math.round(y * svgRatio.y)
                const realWidth = Math.round(width * svgRatio.x)
                const realHeight = Math.round(height * svgRatio.y)

                if (realWidth <= 0 || realHeight <= 0) return

                const newVal = [realX, realY, realWidth, realHeight].join(',')
                console.log("[Cropper Debug] Event Crop - Valeurs corrigées enregistrées :", newVal);

                input.val(newVal)
                input.data('cropperChanging', true).trigger('change').data('cropperChanging', false)
            }
        })
    }

    // Orchestre la vérification SVG avant d'initialiser Cropper
    const handleImageReady = async () => {
        console.log("[Cropper Debug] handleImageReady déclenché");
        const src = imgElement.src || ''
        const isSvg = src.includes('.svg') || src.startsWith('data:image/svg+xml')

        if (isSvg) {
            console.log("[Cropper Debug] Type SVG détecté, extraction lancée...");
            const dimensions = await getSvgViewBoxDimensions(src)
            
            if (dimensions) {
                svgRatio.x = dimensions.width / (imgElement.naturalWidth || 116)
                svgRatio.y = dimensions.height / (imgElement.naturalHeight || 150)
                console.log("[Cropper Debug] Ratios de conversion calculés :", svgRatio);
            } else {
                console.warn("[Cropper Debug] Échec de la récupération des dimensions de la viewBox.");
            }
        } else {
            console.log("[Cropper Debug] Image standard détectée (pas un SVG). Ratios à 1:1.");
            svgRatio = { x: 1, y: 1 }
        }

        initCropper()
    }

    // Sécurité de chargement d'image calquée sur l'architecture existante
    if (imgElement.complete && imgElement.naturalWidth > 0) {
        console.log("[Cropper Debug] L'image est déjà complètement chargée en cache.");
        handleImageReady()
    } else {
        console.log("[Cropper Debug] L'image n'est pas prête, attente de l'événement 'load'...");
        image.on('load', handleImageReady)
    }

    // 2. Écoute les changements externes sur l'input
    input.on('change', function () {
        if (!cropper || !isReady || input.data('cropperChanging')) return

        const adaptedData = getAdaptedData(parseInputVal(input.val()))
        console.log("[Cropper Debug] Changement externe détecté sur l'input. Données adaptées :", adaptedData);
        
        if (adaptedData) {
            input.data('cropperSetting', true)
            cropper.setData(adaptedData)
            input.data('cropperSetting', false)
        }
    })

    return data
}